/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { Layout, Button, Typography, Card, Form, Input, Space, Flex, Modal, Alert } from "antd";
import { message } from "antd";
import logo4 from "../assets/images/logo_ak_mark.png";
import banner from "../assets/images/login_banner.jpg";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import SystemService from "../service/SystemService";
import { Authenticate } from "../service/Authenticate.service";
import { portalToken } from "../portal/portalApi";

const { Title } = Typography;
const { Header, Footer, Content } = Layout;
const authService = Authenticate();
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [logined, setLogined] = useState(false); 
  /* ข้อความจากหน้าลูกค้า เช่น บัญชีถูกปิด / รหัสถูกเปลี่ยน */
  const [sp] = useSearchParams();
  const [notice, setNotice] = useState(sp.get("m") || "");
  const [busy, setBusy] = useState(false);
  useEffect( () => {
    const isLogin = () => { 
      const isAuthen = authService.isExpireToken(); 
      if(!!isAuthen) direcetSystem();
      else if (portalToken.get()) navigate("/portal", { replace: true });
      else setLogined(true);
    }
    

    // console.log(curLocation);
    // setCurr(curLocation);
    isLogin();

    // SystemService.getUnit()    
    //   .then((res) => {
    //     let { status, data } = res;
    //     if (status === 200) {
    //       console.log(data);
    //     }
    //   })
    //   .catch((err) => {});
  }, []);

  const onFinish = (values) => {
    // alert(values.password, values);
    Connectapp(values);
  };
  const direcetSystem = () => { 
    const curr = authService.getCurrent(); 
    navigate("/modules", { replace: true });
    // navigate(!!curr ? curr : "/items", { replace: true });
  }

  const Connectapp = (values) => {
    setBusy(true);
    setNotice("");
    SystemService.signIn(values)
      .then((res) => {
        let { status, data } = res;
        const { token } = data; 
        if (status === 200) {
          if (data?.status === "1" && data?.kind === "customer") {
            /* ลูกค้า → หน้าติดตามบ้านของตัวเอง (token แยกจากพนักงาน) */
            portalToken.set(token);
            navigate("/portal", { replace: true });
          } else if (data?.status === "1") {
            portalToken.clear();
            authService.setToken(token);

            direcetSystem();
          } else {
            Modal.error({
              title: <strong>{data.message}</strong>,
              content: 'Login request failed...',
            });
              // Swal.fire({
              //   title: "<strong>" + data.message + "</strong>",
              //   html: "ผิดพลาด",
              //   icon: "error",
              // });            
          }
        } else {
          Modal.error({
            title: <strong>Login ผิดพลาด!</strong>,
            content: 'Login request failed...',
          });
          // Swal.fire({
          //   title: "<strong>Login ผิดพลาด!</strong>",
          //   html: data.message,
          //   icon: "error",
          // });
        }
      })
      .catch((err) => {
        message.error("Login request failed.");
      })
      .finally(() => setBusy(false));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };


  return (
    <>
      {logined ? (
        <div className="ak-login">
          <div className="ak-login-banner">
            <img src={banner} alt="เอ เค โฮม ศูนย์รับสร้างบ้าน" />
          </div>

          <Card className="ak-login-card" bordered={false}>
            <Flex vertical align="center" gap={4} className="mb-4">
              <img src={logo4} alt="AK-HOME" className="ak-login-logo" />
              <Title level={4} className="!m-0">
                เข้าสู่ระบบ
              </Title>
            </Flex>
            {notice && <Alert type="warning" showIcon message={notice} className="mb-3" closable onClose={() => setNotice("")} />}
            <Form name="basic" layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed} requiredMark={false}>
              <Form.Item name="username" rules={[{ required: true, message: "กรุณากรอก Username" }]}>
                <Input prefix={<UserOutlined />} placeholder="Username (ลูกค้าใช้เบอร์โทร)" autoComplete="username" autoCapitalize="none" />
              </Form.Item>
              <Form.Item name="password" rules={[{ required: true, message: "กรุณาใส่รหัสผ่าน" }]}>
                <Input.Password prefix={<LockOutlined />} placeholder="Password" autoComplete="current-password" autoCapitalize="none" />
              </Form.Item>
              <Form.Item className="!mb-1">
                <Button type="primary" size="large" htmlType="submit" block loading={busy}>
                  เข้าสู่ระบบ
                </Button>
              </Form.Item>
            </Form>
          </Card>

          <div className="ak-login-footer">
            © AK-HOME · พัฒนาโดย{" "}
            <a href="https://www.facebook.com/jaroonsoft" target="_blank" rel="noopener noreferrer">
              Jaroon Software
            </a>
          </div>
        </div>
      ) : (
        <Navigate to="/login" state={{ from: location }} replace />
      )}
    </>
  );
};

export default Login;
